import { render, staticRenderFns } from "./indexv1.vue?vue&type=template&id=1fe74c70&scoped=true&"
import script from "./indexv1.vue?vue&type=script&lang=js&"
export * from "./indexv1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fe74c70",
  null
  
)

export default component.exports